import React, { useState } from 'react';
import './App.css';

function App() {
  const [ciphertext, setCiphertext] = useState('');
  const [plaintext, setPlaintext] = useState('');
  const [key, setKey] = useState('');

  function encrypt(text, key) {
    if (!text || !key) return '';
    let result = '';
    for (let i = 0; i < text.length; i++) {
      const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      result += String.fromCharCode(charCode);
    }
    return btoa(result);
  }

  function decrypt(encryptedText, key) {
    if (!encryptedText || !key) return '';
    try {
      const text = atob(encryptedText);
      let result = '';
      for (let i = 0; i < text.length; i++) {
        const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
        result += String.fromCharCode(charCode);
      }
      return result;
    } catch (e) {
      return '解密失败: 无效的输入';
    }
  }

  const handleEncrypt = () => {
    if (!plaintext || !key) return;
    const encrypted = encrypt(plaintext, key);
    setCiphertext(encrypted);
  };

  const handleDecrypt = () => {
    if (!ciphertext || !key) return;
    const decrypted = decrypt(ciphertext, key);
    setPlaintext(decrypted);
  };

  return (
    <div className="crypto-container">
      <h1 className="page-title">加密解密工具</h1>
      
      <div className="crypto-content">
        <div className="text-area-container">
          <h2>密文</h2>
          <textarea
            className="crypto-textarea"
            value={ciphertext}
            onChange={(e) => setCiphertext(e.target.value)}
            placeholder="密文区域"
          />
        </div>
        
        <div className="controls-container">
          <div className="key-container">
            <label htmlFor="key-input">密钥</label>
            <input
              id="key-input"
              type="text"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="请输入密钥"
              className="key-input"
            />
          </div>
          
          <div className="buttons-container">
            <button className="crypto-button decrypt" onClick={handleDecrypt}>
              <span className="arrow">→</span>
              <span className="tooltip">解密</span>
            </button>
            <button className="crypto-button encrypt" onClick={handleEncrypt}>
              <span className="arrow">←</span>
              <span className="tooltip">加密</span>
            </button>
          </div>
        </div>
        
        <div className="text-area-container">
          <h2>明文</h2>
          <textarea
            className="crypto-textarea"
            value={plaintext}
            onChange={(e) => setPlaintext(e.target.value)}
            placeholder="明文区域"
          />
        </div>
      </div>
    </div>
  );
}

export default App;